<template>
  <program-instructions
    v-if="!isPinned && visible"
    :program="sessionProgram.program"
    :video-max-seek="videoViewTime"
    :video-time-update-interval="10"
    :session-paused="sessionPaused"
    :disable-automation-actions="!hasFinishedVideo"
    @video-time-update="onVideoTimeUpdate"
    @video-completed="onVideoCompleted"
    @automation-action-completed="onAutomationActionCompleted"
  />
</template>
<script>

import ProgramInstructions from 'components/Programs/ProgramInstructions';
import { get } from 'lodash';
import DataCollectionProgram from 'src/mixins/DataCollectionProgram';

export default {
  name: 'InstructionsProgram',

  components: {
    ProgramInstructions,
  },

  mixins: [DataCollectionProgram],

  emits: ['record-program-data', 'automation-action-completed'],

  computed: {

    isPinned() {
      return get(this.sessionProgram, 'pinned', false);
    },

    isStaffTrainingSession() {
      return (this.sessionType === 'training');
    },

    videoViewTime() {
      if (this.hasFinishedVideo) {
        return null;
      }
      return get(this.data, 'videoViewTime', 0);
    },

    hasFinishedVideo() {
      if (!this.isStaffTrainingSession) {
        return true;
      }
      return get(this.data, 'videoViewCompleted', false);
    },

  },

  methods: {

    onAutomationActionCompleted(automationActionResults) {
      this.$emit('automation-action-completed', automationActionResults);
    },

    onVideoTimeUpdate(videoViewTime = 0) {
      if (!this.isStaffTrainingSession) {
        return;
      }
      if (videoViewTime < this.videoViewTime) {
        return;
      }
      const dataObj = {
        videoViewTime,
      };
      this.$emit('record-program-data', this.sessionProgram, dataObj);
    },

    onVideoCompleted() {
      if (!this.isStaffTrainingSession) {
        return;
      }
      const dataObj = {
        videoViewCompleted: true,
      };
      this.$emit('record-program-data', this.sessionProgram, dataObj);
    },

  },
};
</script>
